import React, { useState, useEffect, useCallback } from "react";
import { Select, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getcategoryNode,
  getcreateTrailData,
  gettrailData,
} from "../../../store/user/actions";
import { resettrailDataState } from "../../../store/user/userSlice";
import axios from "axios";
import { getToken } from "../../../util/Common";
import { BASE_URL } from "../../../BaseUri/BaseUri";
import { toast } from "react-toastify";

const AddTrail = ({ sampleTrail, trail, trailAddM, trailDataSX }) => {
  const initialValues = {
    trail_name: "",
  };

  const [newNode, setNewNode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [formValues, setFormValue] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const trailData = useSelector((state) => state.trailData);
  const createTrailData = useSelector((state) => state.createTrailData);
  const dispatch = useDispatch();

  const [isNew, setIsNew] = useState(false);

  const [isEmpty, setIsEmpty] = useState(null);

  const handleTrailChange = useCallback(async (value) => {
    if (value == 0) {
      setNewNode(true);
    } else {
      setIsEmpty(true);
      setIsNew(false);
      // dispatch(gettrailData(value));
      try {
        const response = await axios.post(
          `${BASE_URL}/get-trail/${value}`,
          {},
          {
            headers: { Authorization: `Bearer ${getToken()}` },
          }
        );

        console.log("RESPONSEXSD: ", response?.data);

        if (response?.data?.status === 1) {
          trailAddM(false);
          trailDataSX(response?.data?.data);
          // setIsNew(false);
          console.log("1001:", trailData.data);
          setIsEmpty(null);
          dispatch(getcategoryNode({ id: value, trail: response?.data?.data }));
        }
        if (response?.data?.status === 0) {
          toast.error(response?.data?.message);
        }
      } catch (error) {
        console.error("Error posting data:", error);
      }
    }
  }, []);

  useEffect(() => {
    setNewNode(false);
    if (trailData.isSuccess && isEmpty) {
      trailAddM(false);
      trail(trailData.data);
      // setIsNew(false);
      setIsEmpty(null);
      // dispatch(resettrailDataState());
    }
  }, [trailData.isSuccess, isEmpty]);

  // console.log("RECT: ", trailData);

  const handleChange = useCallback((name, value) => {
    let data = { ...formValues };
    data[name] = value;
    setFormValue(data);
    // setIsNew(true);
  }, []);

  const handleSubmit = async (e, name, value) => {
    setError(null);
    setLoading(true);
    let check = validate(formValues);
    let data = { ...initialValues };
    data[name] = value;
    e.preventDefault();
    setFormErrors(check.errors);
    if (check.isValid) {
      setLoading(false);
      if (newNode) {
        setIsNew(true);
        // dispatch(getcreateTrailData({ name: formValues.trail_name }));
        try {
          const response = await axios.post(
            `${BASE_URL}/create-trail`,
            {
              name: formValues.trail_name,
            },
            {
              headers: { Authorization: `Bearer ${getToken()}` },
            }
          );

          console.log("RESPONSE: ", response?.data);

          if (response?.data?.status === 1) {
            // console.log("MM ASHISH: ", response);
            toast.success(response?.data?.message);
            trail(response?.data?.data);
            setNewNode(false);
            trailAddM(false);
            setIsNew(false);
            // setIsEmpty(true);
            // setIsEmpty(null);
            // trailAddM(false);
          }
        } catch (error) {
          // toast.error("Failed to load more data.");
        }
      }
    }
  };

  // useEffect(() => {
  //   if (createTrailData.isSuccess && isNew) {
  //     console.log("MM ASHISH: ", createTrailData);
  //     trail(createTrailData.data);
  //     setNewNode(false);
  //     trailAddM(false);
  //     setIsNew(false);
  //   }
  // }, [createTrailData, isNew, trail]);

  // console.log(createTrailData.data, "OKANI");

  // validation-start
  useEffect(() => {
    if (Object.keys(formErrors).length > 0) {
    }
  }, [formErrors]);

  const validate = (values) => {
    let isValid = true;
    const errors = {};
    if (!values.trail_name) {
      isValid = false;
      errors.trail_name = "Enter Trail Name";
    }
    return {
      isValid,
      errors,
    };
  };

  return (
    <div className="remark-select">
      <h6>Trail</h6>
      <Select
        defaultValue="Select Trail"
        onChange={handleTrailChange}
        options={sampleTrail}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) =>
          (option?.label.toLowerCase() ?? "").includes(input.toLowerCase())
        }
        filterSort={(option) =>
          (option?.label ?? "")
            .toLowerCase()
            .localeCompare((option?.label ?? "").toLowerCase())
        }
      />
      {newNode ? (
        <div>
          <h6>Trail Name</h6>
          <input
            placeholder="Trail Name"
            className="input-custom form-control"
            onChange={(e) => handleChange("trail_name", e.target.value)}
            style={{
              height: "48px",
              width: "100%",
            }}
          />
          <span className="error-msg">{formErrors.trail_name}</span>
        </div>
      ) : (
        ""
      )}
      <div className="remark-buttons mt-4">
        <button className="dark-but" onClick={handleSubmit}>
          submit
        </button>
      </div>
    </div>
  );
};

export default AddTrail;
